import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import Box from 'assets/components/box/Box';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import { getLocales } from 'assets/locales/Locale';
import {
  StatementBalanceEmailTemplateAction,
  useStatementBalanceEmailTemplateProvider,
} from '../StatementBalanceEmailTemplate.Hooks';

export default function EmailTemplateList() {
  const { lang } = getLocales();
  const { listApi, pageRouter, permissions } = useStatementBalanceEmailTemplateProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.emailTemplates}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple} data-loacing={listApi.isExecuting ? true : undefined}>
      <thead>
        <tr>
          <th>{lang.name}</th>
          <th>{lang.senderName}</th>
          <th>{lang.senderEmail}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: emailTemplate }) => (
            <tr key={emailTemplate.id}>
              <td>
                <b>{emailTemplate.name}</b>
              </td>
              <td>{emailTemplate.senderName}</td>
              <td>{emailTemplate.senderEmail}</td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: emailTemplate.id.toString(),
                      action: StatementBalanceEmailTemplateAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_EMAILTEMPLATE}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{ title: lang.edit }}
                    active
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: emailTemplate.id.toString(),
                      action: StatementBalanceEmailTemplateAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_EMAILTEMPLATE}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{ title: lang.delete }}
                    active
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
